import React, {useEffect, useRef, useState} from "react";
import {
  DieuDuongSVG,
  DuocVatTuSVG,
  GlassSVG,
  KhamBenhSVG,
  KhucXaSVG,
  PaySVG,
  SurgeryIconSVG,
  SettingSVG,
  TiepNhanSVG,
  XetNghiemSVG,
  ChanDoanSvg,
  CustomerCareSVG,
  CSKHSvg,
  NoiTruSVG,
  DienTimSVG,
  PartnerExchange,
  Calculate,
  ServicePackageSVG,
  UploadSVG,
  UploadXmlSVG,
  AccoutingFinacialSVG,
} from "assets/images";
import {Col, MenuProps, Modal, Row, Space} from "antd";
import {Menu, Layout} from "antd";
import Icons from "assets/icons";
import {logoIconWhite, logoFullWhite} from "assets/images/logo";
import {
  siderData as siderDataInit,
  menus as menusInit,
  pushSiderData,
} from "./sider.config";
import "./sider.scss";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "redux/store";
import {
  getListPhongSiderAPI,
  setActiveKey,
  setCollapsed,
  setSiderKey,
} from "redux/reducer/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import SiderIcon from "components/common/SiderIcon/SiderIcon";
import {Link, useNavigate} from "react-router-dom";
import {isValuable, toNumber} from "helper/common";
import {employeeService, pharmacyStoreService} from "api";
import {tabKeys} from "types/enums";
import usePermission from "hooks/usePermission";
import {ExclamationCircleFilled} from "@ant-design/icons";
import {setIsChangetab} from "redux/reducer/residentialNurse";
import {setIdRefraction} from "redux/reducer/pending";
import {setIdDiagnose} from "redux/reducer/diagnose";
const {Sider} = Layout;

// const items: MenuProps["items"] = siderData;

type Props = {
  siderMenuSelected: string;
  setSiderMS: (key: string) => void;
};
//
const SiderCustom: React.FC<Props> = ({siderMenuSelected, setSiderMS}) => {
  const siderKey = useAppSelector(state => {
    return state.common.siderKey;
  });
  const refreshCallPayroll = useAppSelector(
    state => state.common.refreshCallPayroll
  );
  const navigate = useNavigate();
  const {isAdminHCNS} = usePermission();

  //Xem có muốn chuyển tab k?
  const isChangeTab = useAppSelector(e => e.residentialNurse.isChangeTab);

  const closeModal = () => {
    // setOpenModalConfirm(false);
    dispatch(setIsChangetab(true));
  };
  const onOk = () => {
    dispatch(setIsChangetab(false));
    // localStorage.setItem("currentTab", key);
    // dispatch(setActiveKey(key));
  };

  const showModal = () => {
    console.log("after", localStorage.getItem("currentTab"));

    Modal.confirm({
      title: "Bạn có muốn thoát mà không lưu?",
      icon: <ExclamationCircleFilled />,
      onOk() {
        onOk();
      },
      onCancel() {
        closeModal();
      },
      cancelText: "Ở lại",
      okText: "Thoát",
      okType: "danger",
    });
  };

  //********************************************* */

  const onClick: MenuProps["onClick"] = e => {
    console.log("🚀 ~ e:", e);
    setSiderMS(e.key);
    dispatch(setSiderKey(e.key));

    if (e.key != "khucXa") {
      dispatch(setIdRefraction(null));
    }
    if (e.key != '"chanDoan"') {
      dispatch(setIdDiagnose(null));
    }
  };

  let interval = useRef<any>();
  const listPhongSider = useAppSelector(state => state.common.listPhongSider);
  const [menus, setMenus] = useState(menusInit);
  const [items, setItems] = useState<MenuProps["items"]>(siderDataInit);
  const [quantityApprovePayroll, setQuantityApprovePayroll] =
    useState<number>(0);
  const [quantityXuatNhapKho, setQuantityXuatNhapKho] = useState<any>();
  const collapsed = useSelector((state: RootState) => state.common.collapsed);
  const dispatch = useAppDispatch();
  useEffect(() => {
    const getQuantityApprovePayroll = async () => {
      const res = await employeeService.getQuantityApprove();
      setQuantityApprovePayroll(res.data.so_luong_can_duyet);
    };
    getQuantityApprovePayroll();
  }, [refreshCallPayroll]);
  useEffect(() => {
    const setQuantityPatient = listPhongSider => {
      const kham1_t1 = listPhongSider?.find(phong => phong?.maPhong == "PHK1");
      const kham2_t1 = listPhongSider?.find(phong => phong?.maPhong == "PHK2");
      const kham3_t1 = listPhongSider?.find(phong => phong?.maPhong == "PHK3");
      const kham1_t2 = listPhongSider?.find(
        phong => phong?.maPhong == "PHK1-T2"
      );
      const kham2_t2 = listPhongSider?.find(
        phong => phong?.maPhong == "PHK2-T2"
      );
      const khamVip = listPhongSider?.find(phong => phong?.maPhong == "VIP");
      const khucXa = listPhongSider?.find(phong => phong?.maPhong == "KX");
      const khucXa2 = listPhongSider?.find(phong => phong?.maPhong == "KX_T2");
      const dieuDuong = listPhongSider?.find(phong => phong?.maPhong == "DD");
      const dieuDuong2 = listPhongSider?.find(
        phong => phong?.maPhong == "DD-T2"
      );
      const xetNghiem = listPhongSider?.find(phong => phong?.maPhong == "XN");
      const tuVan = listPhongSider?.find(phong => phong?.maPhong == "TV");
      const tuVan2 = listPhongSider?.find(phong => phong?.maPhong == "TV-T2");
      const noiTru = listPhongSider?.find(phong => phong?.maPhong == "IT");
      const dienTim = listPhongSider?.find(phong => phong?.maPhong == "STH");
      const cdha = listPhongSider?.find(phong => phong?.maPhong == "CDM");
      if (menus.find(e => e.key == "khamBenh")) {
        menus.find(e => e.key == "khamBenh").icon = (
          <SiderIcon
            icon={<KhamBenhSVG />}
            quantity={
              toNumber(kham1_t1?.soBenhNhan) +
              toNumber(kham2_t1?.soBenhNhan) +
              toNumber(kham3_t1?.soBenhNhan) +
              toNumber(kham1_t2?.soBenhNhan) +
              toNumber(kham2_t2?.soBenhNhan) +
              toNumber(khamVip?.soBenhNhan)
            }
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "khucXa")) {
        menus.find(e => e.key == "khucXa").icon = (
          <SiderIcon
            icon={<KhucXaSVG />}
            quantity={
              toNumber(khucXa?.soBenhNhan) + toNumber(khucXa2?.soBenhNhan)
            }
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "dieuDuongNgoaiTru")) {
        menus.find(e => e.key == "dieuDuongNgoaiTru").icon = (
          <SiderIcon
            icon={<DieuDuongSVG />}
            quantity={
              toNumber(dieuDuong?.soBenhNhan) + toNumber(dieuDuong2?.soBenhNhan)
            }
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "xetNghiem")) {
        menus.find(e => e.key == "xetNghiem").icon = (
          <SiderIcon
            icon={<XetNghiemSVG />}
            quantity={xetNghiem?.soBenhNhan}
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "tuVanDieuTri")) {
        menus.find(e => e.key == "tuVanDieuTri").icon = (
          <SiderIcon
            icon={<CSKHSvg />}
            quantity={
              toNumber(tuVan?.soBenhNhan) + toNumber(tuVan2?.soBenhNhan)
            }
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "dieuTriNoiTru")) {
        menus.find(e => e.key == "dieuTriNoiTru").icon = (
          <SiderIcon
            icon={<NoiTruSVG />}
            quantity={noiTru?.soBenhNhan}
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "dienTim")) {
        menus.find(e => e.key == "dienTim").icon = (
          <SiderIcon
            icon={<DienTimSVG />}
            quantity={dienTim?.soBenhNhan}
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "chanDoan")) {
        menus.find(e => e.key == "chanDoan").icon = (
          <SiderIcon
            icon={<ChanDoanSvg />}
            quantity={cdha?.soBenhNhan}
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "tinh-luong")) {
        menus.find(e => e.key == "tinh-luong").icon = (
          <SiderIcon
            icon={<Calculate />}
            quantity={quantityApprovePayroll}
          ></SiderIcon>
        );
      }
      if (menus.find(e => e.key == "tinh-luong")) {
        const parent = menus.find(e => e.key == "tinh-luong");
        if (parent) {
          const fMenu = parent?.subItems?.find(
            sub => sub.key === "duyetBangLuong"
          );
          const fMenuHCNS = parent?.subItems?.find(
            sub => sub.key === "bangLuong"
          );

          if (fMenuHCNS && isAdminHCNS())
            fMenuHCNS.icon = (
              <SiderIcon
                icon={<></>}
                quantity={quantityApprovePayroll}
              ></SiderIcon>
            );
          else if (fMenu)
            fMenu.icon = (
              <SiderIcon
                icon={<></>}
                quantity={quantityApprovePayroll}
              ></SiderIcon>
            );
        }
      }
      setMenus([...menus]);
    };
    setQuantityPatient(listPhongSider);
  }, [listPhongSider, quantityApprovePayroll]);
  useEffect(() => {
    const setQuantityXuatNhapKhoSider = quantityXuatNhapKho => {
      if (menus?.find(e => e?.key == "thuoc-vat-tu")) {
        const parent = menus?.find(e => e?.key == "thuoc-vat-tu");
        parent.icon = (
          <SiderIcon
            icon={<DuocVatTuSVG></DuocVatTuSVG>}
            quantity={
              toNumber(quantityXuatNhapKho?.TH) +
              toNumber(quantityXuatNhapKho?.VTYT)
            }
          ></SiderIcon>
        );
        if (isValuable(parent?.subItems?.find(e => e?.key == "khoDuoc"))) {
          const khoDuoc = parent?.subItems?.find(e => e?.key == "khoDuoc");
          khoDuoc.icon = (
            <SiderIcon
              icon={<></>}
              quantity={quantityXuatNhapKho?.TH}
            ></SiderIcon>
          );
        }
        if (isValuable(parent?.subItems?.find(e => e?.key == "khoVatTu"))) {
          const khoVatTu = parent?.subItems?.find(e => e?.key == "khoVatTu");
          khoVatTu.icon = (
            <SiderIcon
              icon={<></>}
              quantity={quantityXuatNhapKho?.VTYT}
            ></SiderIcon>
          );
        }
      }
      setMenus([...menus]);
    };
    setQuantityXuatNhapKhoSider(quantityXuatNhapKho);
  }, [quantityXuatNhapKho]);
  const hasPermission = menu => {
    const listMenuOfUser =
      localStorage.getItem("listMenu") != undefined &&
      localStorage.getItem("listMenu") != null
        ? JSON.parse(localStorage.getItem("listMenu"))
        : [];
    let isSubItemsPermissed = false;
    if (menu?.subItems?.length > 0) {
      const listMenuOfSubItems = menu?.subItems?.map(e => e?.key);
      isSubItemsPermissed = listMenuOfSubItems.some(e =>
        listMenuOfUser.includes(e)
      );
    }
    const isPermissed =
      listMenuOfUser.includes(menu?.key) || isSubItemsPermissed;
    // ||
    // listRoleOfUser?.includes("admin");

    return isPermissed;
  };
  useEffect(() => {
    const setRolesMenu = () => {
      const roleMenus = menus
        .filter(menu => hasPermission(menu))
        .map(menu => {
          if (menu?.subItems?.length > 0) {
            return {
              ...menu,
              subItems: menu.subItems.filter(subItem => hasPermission(subItem)),
            };
          } else {
            return menu;
          }
        });

      setMenus([...roleMenus]);
    };
    setRolesMenu();
  }, []);

  useEffect(() => {
    interval.current = setInterval(() => {
      dispatch(getListPhongSiderAPI());
    }, 20000);
    return () => {
      clearInterval(interval.current);
      interval.current = null;
    };
  }, []);
  useEffect(() => {
    const getCanhBaoNhapXuat = async () => {
      try {
        const res = await pharmacyStoreService.getCanhBaoXuatNhap();
        setQuantityXuatNhapKho(res);
      } catch (error) {
        setQuantityXuatNhapKho(null);
      }
    };
    interval.current = setInterval(() => {
      getCanhBaoNhapXuat();
    }, 20000);
    return () => {
      clearInterval(interval.current);
      interval.current = null;
    };
  }, []);

  useEffect(() => {
    const siderData: any[] = [];
    const checkIncludeKey = (menus): boolean => {
      let isInclude = false;
      if (menus.findIndex(menu => menu.key == siderKey) > -1) {
        isInclude = true;
      } else {
        menus.forEach(menu => {
          if (
            menu?.subItems?.findIndex(subItem => subItem?.key == siderKey) > -1
          ) {
            isInclude = true;
          }
        });
      }
      return isInclude;
    };
    const setDefaultKey = () => {
      if (
        (!siderKey || !checkIncludeKey(menus)) &&
        (!localStorage.getItem("currentTab") ||
          localStorage.getItem("currentTab") == tabKeys.RECEIVE.TAB_1)
      ) {
        dispatch(setSiderKey(menus?.[0]?.key));
        localStorage.setItem("currentSider", menus?.[0]?.key);
        if (
          isValuable(menus?.[0]?.link) ||
          isValuable(menus?.[0]?.subItems?.[0]?.link)
        ) {
          navigate(menus?.[0]?.link ?? menus?.[0]?.subItems?.[0]?.link);
        }
      }
    };
    pushSiderData(menus, siderData);
    // if (!window.REACT_APP_BE_URL.includes("alina")) {
    //   setDefaultKey();
    // }
    setDefaultKey();

    setItems([...siderData]);
  }, [menus]);
  return (
    <Sider
      className="sider"
      theme="light"
      collapsible
      collapsedWidth="80"
      breakpoint="md"
      width={250}
      collapsed={collapsed}
      onCollapse={(boolean, type) => {
        if (boolean) {
          dispatch(setCollapsed(boolean));
        }
      }}
      trigger={null}
    >
      <div className="logo-container">
        <Row className="sider-logo-box" justify="center" align={"middle"}>
          <Col>
            <Space>
              {!collapsed && (
                <div className="sider-logo-title">
                  <img src={logoFullWhite} alt="" />
                </div>
              )}
              {collapsed && <img src={logoIconWhite} alt="" />}
            </Space>
          </Col>
        </Row>
      </div>
      <Menu
        onClick={onClick}
        mode="inline"
        inlineIndent={10}
        items={items}
        selectedKeys={[siderKey]}
      />
    </Sider>
  );
};

export default SiderCustom;
